(function () {
  if (window.Product) return;

  window.Product = class Product extends HTMLElement {
    constructor() {
      super();

      this.thumbnailsContainer = this.querySelector(".js-product-page-thumbnails");
      this.scrollbar = this.querySelector(".js-custom-vertical-scrollbar");
      this.imagesContainer = this.querySelector(".js-product-page-images");
      this.thumbnails = this.querySelectorAll(".js-product-page-thumbnail");
      this.productImages = this.querySelectorAll(".js-product-page-image");
      this.quantityInput = this.querySelector(".js-quantity-field");
      this.quantityUp = this.querySelector(".js-quantity-up");
      this.quantityDown = this.querySelector(".js-quantity-down");

      if (this.thumbnailsContainer && this.scrollbar && this.imagesContainer) {
        this.updateScrollbar = this.updateScrollbar.bind(this);
        this.updateThumbnailsHeight = this.updateThumbnailsHeight.bind(this);
        this.onThumbnailInteraction = this.onThumbnailInteraction.bind(this);

        this.thumbnailsContainer.addEventListener("scroll", this.updateScrollbar);
        this.thumbnailsContainer.addEventListener("mouseenter", this.updateScrollbar);
        window.addEventListener("resize", this.updateThumbnailsHeight);

        this.thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener("click", this.onThumbnailInteraction);
          thumbnail.addEventListener("mouseenter", this.onThumbnailInteraction);
        });

        setTimeout(() => {
          this.updateThumbnailsHeight();
        }, 100);
      }

      if (this.quantityInput && this.quantityUp && this.quantityDown) {
        this.updateQuantityDown = this.updateQuantityDown.bind(this);
        this.updateQuantityUp = this.updateQuantityUp.bind(this);

        this.quantityDown.addEventListener("click", this.updateQuantityDown);
        this.quantityUp.addEventListener("click", this.updateQuantityUp);
      }

      if(!this.isQuickView()) {
        this.loadComplementaryProducts();
        this.loadRelatedProducts();
      }
      this.productForm();
      this.productVideos();
      this.moveBuyNowButton();
      this.sizeGuideModal();
      this.backInStockModal();
      if(!this.isQuickView()) {
        this.productTabs();
        this.toggleProductTab();
        this.accordionTabs();
        this.initProductImageDots();
        if (this.querySelector('.js-product-layout-1')) {
          this.initThumbnailScrollSync();
        }
        this.initThumbnailCarousel();
      }
      this.applyAffiliateLink();
      this.applyPreorder();
      this.countDown();
      this.photoswipeZoom();
    }

    isQuickView() {
      return !!this.closest('.js-quickview');
    }

    productForm() {
      const variants = (productId, sectionId) => {
        const data = JSON.parse(document.getElementById(`ProductJson${productId}`).innerHTML);

        const selectCallback = (variant) => {
          const that = this.querySelector(`.js-product[data-product-id='${productId}']`);
          if (variant && that) {
            const priceOldElement = that.querySelector(".js-price-old");
            const priceNewElement = that.querySelector(".js-price-new");
            const priceDefaultElement = that.querySelector(".js-price-default");

            if (variant.compare_at_price > variant.price) {
              if (priceOldElement) {
                priceOldElement.classList.remove("d-none");
                priceOldElement.innerHTML = Shopify.formatMoney(variant.compare_at_price);
              }
              if (priceNewElement) {
                priceNewElement.classList.remove("d-none");
                priceNewElement.innerHTML = Shopify.formatMoney(variant.price);
              }
              if (priceDefaultElement) {
                priceDefaultElement.classList.add("d-none");
              }
            } else {
              if (priceOldElement) priceOldElement.classList.add("d-none");
              if (priceNewElement) priceNewElement.classList.add("d-none");
              if (priceDefaultElement) {
                priceDefaultElement.classList.remove("d-none");
                priceDefaultElement.innerHTML = Shopify.formatMoney(variant.price);
              }
            }

            const soldOutWrappers = that.querySelectorAll('.js-product-out-of-stock');
            const addToCartWrappers = that.querySelectorAll('.js-product-action');

            if (!variant.available) {
              that.classList.add("sold-out");
              soldOutWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
              addToCartWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
            } else {
              that.classList.remove("sold-out");
              soldOutWrappers.forEach(wrapper => wrapper.classList.add('d-none'));
              addToCartWrappers.forEach(wrapper => wrapper.classList.remove('d-none'));
            }

            that.querySelectorAll('.js-product-size-wrapper .js-product-size').forEach(sizeElement => {
              let soldOut = true;
              const value = sizeElement.getAttribute('data-value');
              const option = sizeElement.getAttribute('data-option');

              const selectedOptions = {};
              that.querySelectorAll(`.selector-wrapper select`).forEach(select => {
                const optionName = select.getAttribute('data-option');
                if(optionName != option) {
                  selectedOptions[optionName] = select.value;
                }
              });

              that.querySelectorAll(`select[name='id'] option`).forEach(option => {
                const option1 = option.getAttribute('data-option-1');
                const option2 = option.getAttribute('data-option-2');
                const option3 = option.getAttribute('data-option-3');

                const matchesSelectedOptions =
                    (!selectedOptions['option1'] || option1 === selectedOptions['option1']) &&
                    (!selectedOptions['option2'] || option2 === selectedOptions['option2']) &&
                    (!selectedOptions['option3'] || option3 === selectedOptions['option3']);

                if (matchesSelectedOptions && (option1 === value || option2 === value || option3 === value)) {
                  if (!option.hasAttribute('disabled')) {
                    soldOut = false;
                  }
                }
              });

              if (soldOut) {
                sizeElement.classList.add('out-of-stock');
              } else {
                sizeElement.classList.remove('out-of-stock');
              }
            });

            if (variant.featured_media) {
              const targetIndex = variant.featured_media.position;
              const thumbnailToClick = that.querySelector(`.js-product-page-thumbnail[data-index='${targetIndex}']`);
              if (thumbnailToClick) {
                thumbnailToClick.click();
              }
              that.querySelectorAll('.js-add-to-cart').forEach(button => {
                button.setAttribute('data-featured-image', variant.featured_media.preview_image.src + '&width=300');
              });
            }

            const pickupComponent = that.querySelector('pickup-availability');
            if (pickupComponent && typeof pickupComponent.update === 'function') {
              pickupComponent.update(variant);
            }

            const unitPriceEl = that.querySelector('.js-unit-price');

            if (unitPriceEl) {
              if (variant.unit_price && variant.unit_price_measurement) {
                unitPriceEl.innerHTML = 
                  `${Shopify.formatMoney(variant.unit_price)} / ${variant.unit_price_measurement.reference_value} ${variant.unit_price_measurement.reference_unit}`;
                unitPriceEl.classList.remove('d-none');
              } else {
                unitPriceEl.classList.add('d-none');
              }
            }

            const taxNote = that.querySelector('.js-product-tax-note');
            if(taxNote) {
              if (variant.taxable) {
                taxNote.classList.remove('d-none');
              } else {
                taxNote.classList.add('d-none');
              }
            }
          }
        };

        if (document.getElementById(`product-select-${productId}`)) {
          new Shopify.OptionSelectors(`product-select-${productId}`, {
            product: data,
            onVariantSelected: selectCallback,
            enableHistoryState: true
          });
        }
      };

      document.querySelectorAll(".js-product:not(.active)").forEach((element) => {
        const productId = element.getAttribute("data-product-id");
        const json = document.getElementById(`ProductJson${productId}`);

        if (json) {
          variants(productId);

          element.querySelectorAll('.js-product-color').forEach(element => {
            element.addEventListener('click', function (event) {
              event.preventDefault();

              const value = this.getAttribute('data-value');
              const option = this.closest('ul').getAttribute('data-option');

              const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
              if (productVariants) {
                productVariants.value = value;
                productVariants.dispatchEvent(new Event('change'));

                const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-color[data-option="${option}"] p`);
                if (optionValues.length) {
                  optionValues.forEach(optionValue => {
                    optionValue.classList.remove('active');
                  });

                  this.querySelector('p').classList.add('active');
                }

                const optValEl = document.querySelector(
                  `.js-product[data-product-id='${productId}'] .js-product-option-value[data-option='${option}']`
                );
                if (optValEl) optValEl.textContent = value;
              }
            });
          });

          element.querySelectorAll('.js-product-size, .js-product-value').forEach(sizeElement => {
            sizeElement.addEventListener('click', function (event) {
              event.preventDefault();

              const value = this.getAttribute('data-value');
              const option = this.closest('ul').getAttribute('data-option');

              const productVariants = document.querySelector(`.js-product[data-product-id='${productId}'] select[data-option='${option}']`);
              if (productVariants) {
                productVariants.value = value;
                productVariants.dispatchEvent(new Event('change'));

                const optionValues = document.querySelectorAll(`.js-product[data-product-id='${productId}'] .js-product-size[data-option="${option}"], .js-product[data-product-id='${productId}'] .js-product-value[data-option="${option}"]`);
                if (optionValues.length) {
                  optionValues.forEach(optionValue => {
                    optionValue.classList.remove('active');
                  });

                  this.classList.add('active');
                }

                const optValEl = document.querySelector(
                  `.js-product[data-product-id='${productId}'] .js-product-option-value[data-option='${option}']`
                );
                if (optValEl) optValEl.textContent = value;
              }
            });
          });

          element.querySelectorAll('.js-product-select').forEach(selectEl => {
            selectEl.addEventListener('change', function () {
              const option = this.getAttribute('data-option');
              const value = this.value;
              const productId = this.getAttribute('data-product-id');
              const targetSelect = document.querySelector(
                `.js-product[data-product-id='${productId}'] #product-variants select[data-option='${option}']`
              );
              if (targetSelect) {
                targetSelect.value = value;
                targetSelect.dispatchEvent(new Event('change'));
              }
              return false;
            });
          });
          }

        element.classList.add("active");
      });
    }

    productVideos() {
      const playButtons = this.querySelectorAll('.js-play-video');
      const stopButtons = this.querySelectorAll('.js-stop-video');
      const toggleButtons = this.querySelectorAll('.js-toggle-video video');

      playButtons.forEach(button => {
        button.addEventListener('click', function() {
          const video = this.closest('.js-product-page-image').querySelector('video');
          if (video) {
            video.play();
            this.classList.add('d-none');
            const stopButton = this.closest('.js-product-page-image').querySelector('.js-stop-video');
            if (stopButton) stopButton.classList.remove('d-none');
          }
        });
      });

      stopButtons.forEach(button => {
        button.addEventListener('click', function() {
          const video = this.closest('.js-product-page-image').querySelector('video');
          if (video) {
            video.pause();
            this.classList.add('d-none');
            const playButton = this.closest('.js-product-page-image').querySelector('.js-play-video');
            if (playButton) playButton.classList.remove('d-none');
          }
        });
      });

      toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
          const container = this.closest('.js-product-page-image');
          const playButton = container.querySelector('.js-play-video');
          const stopButton = container.querySelector('.js-stop-video');

          if (playButton && playButton.classList.contains('d-none')) {
            stopButton?.click();
          } else {
            playButton?.click();
          }
        });
      });
    }

    moveBuyNowButton() {
      const buyNowButton = this.querySelector('.js-buy-now-product');
      const targetContainer = this.querySelector('.js-get-buy-now');

      if (buyNowButton && targetContainer) {
        targetContainer.appendChild(buyNowButton);
      }
    }

    updateThumbnailsHeight() {
      if (!this.imagesContainer || !this.thumbnailsContainer) return;

      const imagesHeight = this.imagesContainer.clientHeight;
      this.thumbnailsContainer.style.height = `${imagesHeight}px`;
      this.updateScrollbar();
    }

    updateScrollbar() {
      if (!this.thumbnailsContainer || !this.scrollbar) return;

      const scrollHeight = this.thumbnailsContainer.scrollHeight;
      const containerHeight = this.thumbnailsContainer.clientHeight;
      const scrollTop = this.thumbnailsContainer.scrollTop;

      const scrollbarHeight = (containerHeight / scrollHeight) * containerHeight;
      const scrollbarTop = (scrollTop / scrollHeight) * containerHeight;

      this.scrollbar.style.height = `${scrollbarHeight}px`;
      this.scrollbar.style.transform = `translateY(${scrollbarTop}px)`;

      if(scrollHeight == containerHeight) {
        this.scrollbar.classList.add('disabled');
      } else {
        this.scrollbar.classList.remove('disabled');
      }
    }

    onThumbnailInteraction(event) {
      event.preventDefault();

      const index = event.currentTarget.getAttribute("data-index");
      
      this.productImages.forEach(image => {
        image.classList.toggle("active", image.getAttribute("data-index") === index);
      });

      this.thumbnails.forEach(thumbnail => {
        thumbnail.classList.toggle("active", thumbnail.getAttribute("data-index") === index);
      });

      if (window.innerWidth < 992) {
        const container = this.querySelector(".js-product-page-images");
        const targetImage = container.querySelector(`[data-index="${index}"]`);

        if (container && targetImage) {
          container.scrollTo({
              left: targetImage.offsetLeft - container.offsetLeft,
              behavior: "smooth"
          });
        }
      }
    }

    updateQuantityDown(event) {
      event.preventDefault();
      if (!this.quantityInput) return;

      let currentValue = parseInt(this.quantityInput.value, 10) || 1;
      if (currentValue > 1) {
        this.quantityInput.value = currentValue - 1;
      }
    }

    updateQuantityUp(event) {
      event.preventDefault();
      if (!this.quantityInput) return;

      let currentValue = parseInt(this.quantityInput.value, 10) || 1;
      this.quantityInput.value = currentValue + 1;
    }

    createCustomSplideArrows() {
      const arrows = document.createElement("div");
      arrows.classList.add("splide__arrows");

      const prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "splide__arrow splide__arrow--prev";
      prevBtn.setAttribute("aria-label", "Previous");
      prevBtn.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.5 5.5 L8.5 12 L14.5 18.5"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      `;

      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "splide__arrow splide__arrow--next";
      nextBtn.setAttribute("aria-label", "Next");
      nextBtn.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9.5 5.5 L15.5 12 L9.5 18.5"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      `;

      arrows.appendChild(prevBtn);
      arrows.appendChild(nextBtn);
      return arrows;
    }

    loadComplementaryProducts() {
      if (this.hasLoadedComplementary) return;
      this.hasLoadedComplementary = true;

      const complementaryProducts = document.querySelector(".js-complementary-products");
      if (!complementaryProducts) return;

      const url = complementaryProducts.getAttribute("data-url");
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".js-complementary-products");
          if (!recommendations) return;

          complementaryProducts.innerHTML = recommendations.innerHTML;

          const self = this;
          document.querySelectorAll('.js-home-products-carousel').forEach(function (carousel) {
            if (carousel.classList.contains('is-initialized')) return;

            const num = (name, fb = 0) => {
              const v = parseInt(carousel.getAttribute(name), 10);
              return isNaN(v) ? fb : v;
            };

            const largeDesktop = num('data-large-desktop-products-per-row', 1);
            const desktop      = num('data-desktop-products-per-row', largeDesktop);
            const laptop       = num('data-laptop-products-per-row', desktop);
            const tablet       = num('data-tablet-products-per-row', laptop);
            const mobile       = num('data-mobile-products-per-row', tablet);

            const gapLg  = num('data-large-desktop-products-gap', 0);
            const gapD   = num('data-desktop-products-gap', gapLg);
            const gapLap = num('data-laptop-products-gap', gapD);
            const gapTab = num('data-tablet-products-gap', gapLap);
            const gapMob = num('data-mobile-products-gap', gapTab);

            if (!carousel.querySelector('.splide__arrows') && typeof self.createCustomSplideArrows === 'function') {
              carousel.appendChild(self.createCustomSplideArrows());
            }

            const splide = new Splide(carousel, {
              type: 'slide',
              perPage: largeDesktop,
              perMove: 1,
              arrows: true,
              pagination: true,
              rewind: false,
              gap: `${gapLg}px`,
              breakpoints: {
                1798: { perPage: desktop, gap: `${gapD}px` },
                1499: { perPage: laptop,  gap: `${gapLap}px` },
                991:  { perPage: tablet,  gap: `${gapTab}px` },
                767:  { perPage: mobile,  gap: `${gapMob}px` },
              },
            });

            splide.mount();
            carousel.classList.add('is-initialized');
          });

          if (typeof initializeFadeInObserver === "function") initializeFadeInObserver();
          if (typeof wishlistPage === "function") wishlistPage();
          if (typeof initProductGridItemColors === "function") {
            initProductGridItemColors();
          }
        })
        .catch(e => console.error("Error loading complementary products:", e));
    }

    loadRelatedProducts() {
      if (this.hasLoadedRelated) return;
      this.hasLoadedRelated = true;

      const relatedProducts = document.querySelector(".js-related-products");
      if (!relatedProducts) return;

      const url = relatedProducts.getAttribute("data-url");
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const recommendations = doc.querySelector('.js-related-products');
          if (!recommendations) return;

          document.querySelector('.js-related-products').innerHTML = recommendations.innerHTML;

          const self = this;
          document.querySelectorAll('.js-home-products-carousel').forEach(function (carousel) {
            if (carousel.classList.contains('is-initialized')) return;

            const num = (name, fb = 0) => {
              const v = parseInt(carousel.getAttribute(name), 10);
              return isNaN(v) ? fb : v;
            };

            const largeDesktop = num('data-large-desktop-products-per-row', 1);
            const desktop      = num('data-desktop-products-per-row', largeDesktop);
            const laptop       = num('data-laptop-products-per-row', desktop);
            const tablet       = num('data-tablet-products-per-row', laptop);
            const mobile       = num('data-mobile-products-per-row', tablet);

            const gapLg  = num('data-large-desktop-products-gap', 0);
            const gapD   = num('data-desktop-products-gap', gapLg);
            const gapLap = num('data-laptop-products-gap', gapD);
            const gapTab = num('data-tablet-products-gap', gapLap);
            const gapMob = num('data-mobile-products-gap', gapTab);

            if (!carousel.querySelector('.splide__arrows') && typeof self.createCustomSplideArrows === 'function') {
              carousel.appendChild(self.createCustomSplideArrows());
            }

            const splide = new Splide(carousel, {
              type: 'slide',
              perPage: largeDesktop,
              perMove: 1,
              arrows: true,
              pagination: true,
              rewind: false,
              gap: `${gapLg}px`,
              breakpoints: {
                1798: { perPage: desktop, gap: `${gapD}px` },
                1499: { perPage: laptop,  gap: `${gapLap}px` },
                991:  { perPage: tablet,  gap: `${gapTab}px` },
                767:  { perPage: mobile,  gap: `${gapMob}px` },
              },
            });

            splide.mount();
            carousel.classList.add('is-initialized');
          });

          if (typeof initializeFadeInObserver === "function") initializeFadeInObserver();
          if (typeof wishlistPage === "function") wishlistPage();
          if (typeof initProductGridItemColors === "function") {
            initProductGridItemColors();
          }
        })
        .catch(e => console.error("Error loading related products:", e));
    }

    sizeGuideModal() {
      document.body.addEventListener("click", function (e) {
        if (e.target.closest(".js-get-size-guide a")) {
          e.preventDefault();
          document.querySelector(".js-size-guide")?.classList.add("active");
        }

        if (e.target.closest(".js-close-size-guide")) {
          e.preventDefault();
          document.querySelector(".js-size-guide")?.classList.remove("active");
        }
      });
    }

    backInStockModal() {
      document.body.addEventListener("click", function (e) {
        const btn = e.target.closest(".js-notify-me-button");
        if (!btn) return;

        const targetBtn = document.querySelector(".nm-portal button");
        if (targetBtn) targetBtn.click();

        e.preventDefault();
      });
    }

    productTabs() {
      if (document.querySelector(".js-get-default-product-tabs") && document.querySelector(".js-default-product-tabs")) {
        document.querySelector(".js-get-default-product-tabs").innerHTML =
          document.querySelector(".js-default-product-tabs").innerHTML;

        document.querySelectorAll(".d-none.js-default-product-tabs").forEach(el => el.remove());
      }
    }

    toggleProductTab() {
      document.querySelectorAll(".js-open-tab").forEach(btn => {
        btn.addEventListener("click", e => {
          e.preventDefault();
          const id = btn.getAttribute("data-id");
          const tab = document.querySelector(`.js-tab[data-id='${id}']`);
          if (tab) tab.classList.add("active");
        });
      });

      document.querySelectorAll(".js-close-tab").forEach(btn => {
        btn.addEventListener("click", e => {
          e.preventDefault();
          document.querySelectorAll(".js-tab").forEach(tab => tab.classList.remove("active"));
        });
      });
    }

    accordionTabs() {
      const accordions = document.querySelectorAll('.js-accordion');

      accordions.forEach(acc => {
        const title = acc.querySelector(".js-accordion-title");
        const content = acc.querySelector(".js-accordion-content");

        title.addEventListener("click", () => {
          accordions.forEach(a => a.classList.remove("current"));

          acc.classList.toggle("active");
          acc.classList.add("current");

          slideToggle(content, 300);
        });

        if (acc.classList.contains("active")) {
          content.style.display = "block";
          content.style.height = content.scrollHeight + "px";
        }
      });

      function slideToggle(element, duration) {
        if (!element) return;

        if (window.getComputedStyle(element).display === "none") {
          element.style.display = "block";
          let height = element.scrollHeight + "px";
          element.style.height = "0px";
          setTimeout(() => {
            element.style.transition = `height ${duration}ms`;
            element.style.height = height;
          }, 10);
          setTimeout(() => {
            element.style.height = "";
            element.style.transition = "";
          }, duration);
        } else {
          let height = element.scrollHeight + "px";
          element.style.height = height;
          setTimeout(() => {
            element.style.transition = `height ${duration}ms`;
            element.style.height = "0px";
          }, 10);
          setTimeout(() => {
            element.style.display = "none";
            element.style.height = "";
            element.style.transition = "";
          }, duration);
        }
      }
    }

    initProductImageDots() {
      if (!this.productImages || !this.imagesContainer) return;

      const dotsContainer = document.createElement("div");
      dotsContainer.className = "product-image-dots js-product-image-dots";
      this.productImages.forEach((image, idx) => {
        const dot = document.createElement("button");
        dot.className = "product-dot";
        dot.setAttribute("data-index", image.getAttribute("data-index"));
        dot.type = "button";
        dot.addEventListener("click", () => {
          this.setActiveImage(image.getAttribute("data-index"));
          if (window.innerWidth < 992) {
            this.imagesContainer.scrollTo({
              left: image.offsetLeft - this.imagesContainer.offsetLeft,
              behavior: "smooth"
            });
          }
        });
        dotsContainer.appendChild(dot);
      });

      this.imagesContainer.parentElement.appendChild(dotsContainer);

      this.updateActiveDot();

      if (window.innerWidth < 992) {
        this.imagesContainer.addEventListener("scroll", () => {
          this.updateActiveDotOnScroll();
        });
      }
    }

    setActiveImage(index) {
      this.productImages.forEach(image => {
        image.classList.toggle("active", image.getAttribute("data-index") === index);
      });

      this.thumbnails.forEach(thumbnail => {
        thumbnail.classList.toggle("active", thumbnail.getAttribute("data-index") === index);
      });

      this.updateActiveDot();
    }

    updateActiveDot() {
      const activeIndex = this.querySelector(".js-product-page-image.active")?.getAttribute("data-index");
      this.querySelectorAll(".product-dot").forEach(dot => {
        dot.classList.toggle("active", dot.getAttribute("data-index") === activeIndex);
      });
    }

    updateActiveDotOnScroll() {
      let closestImage = null;
      let closestDistance = Infinity;

      this.productImages.forEach(image => {
        const rect = image.getBoundingClientRect();
        const containerRect = this.imagesContainer.getBoundingClientRect();
        const distance = Math.abs(rect.left - containerRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestImage = image;
        }
      });

      if (closestImage) {
        this.setActiveImage(closestImage.getAttribute("data-index"));
      }
    }

    initThumbnailScrollSync() {
      if (!this.productImages.length || !this.thumbnails.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = entry.target.getAttribute('data-index');

            this.thumbnails.forEach(thumbnail => {
              thumbnail.classList.toggle('active', thumbnail.getAttribute('data-index') === index);
            });
          }
        });
      }, {
        root: null,
        threshold: 0.5
      });

      this.productImages.forEach(image => observer.observe(image));

      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          const index = thumbnail.getAttribute('data-index');
          const targetImage = this.imagesContainer.querySelector(`.js-product-page-image[data-index="${index}"]`);

          if (targetImage) {
            const offset = targetImage.offsetTop - 20; 
            window.scrollTo({
              top: offset,
              behavior: 'smooth'
            });
          }
        });
      });
    }

    initThumbnailCarousel() {
      const imagesWrapper = this.querySelector(".js-product-images");
      if (!imagesWrapper) return;

      const thumbsWrapper = imagesWrapper.querySelector(".js-product-page-thumbnails");
      if (!thumbsWrapper) return;

      thumbsWrapper.classList.add("splide");

      const track = document.createElement("div");
      track.classList.add("splide__track");

      const thumbnailsContainer = thumbsWrapper.querySelector(".thumbnails");
      thumbnailsContainer.classList.add("splide__list");

      thumbnailsContainer.querySelectorAll(".product-thumbnail").forEach((item) => {
        item.classList.add("splide__slide");
      });

      track.appendChild(thumbnailsContainer);
      thumbsWrapper.innerHTML = "";
      thumbsWrapper.appendChild(track);

      const arrows = document.createElement("div");
      arrows.classList.add("splide__arrows");

      const prevBtn = document.createElement("button");
      prevBtn.type = "button";
      prevBtn.className = "splide__arrow splide__arrow--prev";
      prevBtn.setAttribute("aria-label", "Previous");
      prevBtn.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.5 5.5 L8.5 12 L14.5 18.5"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      `;

      const nextBtn = document.createElement("button");
      nextBtn.type = "button";
      nextBtn.className = "splide__arrow splide__arrow--next";
      nextBtn.setAttribute("aria-label", "Next");
      nextBtn.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9.5 5.5 L15.5 12 L9.5 18.5"
                fill="none"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      `;

      arrows.appendChild(prevBtn);
      arrows.appendChild(nextBtn);
      thumbsWrapper.appendChild(arrows);

      new Splide(thumbsWrapper, {
        type: "slide",
        perPage: 4,
        perMove: 1,
        gap: "10px",
        pagination: false,
        arrows: true
      }).mount();
    }

    applyAffiliateLink(root = this) {
      const aff = root.querySelector(".js-product-affiliate-link");
      if (!aff) return;

      const url = aff.dataset.url;
      const label = aff.dataset.label;

      if (!url || !label) return;

      root.querySelectorAll(".js-product-action").forEach((el) => {
        el.innerHTML = `
          <div class="product__buttons d-flex">
            <div class="product__button product__button--full-width">
              <a href="${url}" class="second-button" target="_blank" rel="noopener">${label}</a>
            </div>
          </div>
        `;
        el.style.display = "block";
      });

      root.querySelectorAll(".js-quantity-option").forEach((el) => {
        el.remove();
      });
    }

    applyPreorder(root = this) {
      const preorderInfo = root.querySelector(".js-preorder-info");
      if (!preorderInfo) return;

      const label = preorderInfo.dataset.label;
      if (!label) return;

      const addToCartBtn = root.querySelector(".js-product .js-add-to-cart");
      if (!addToCartBtn) return;

      addToCartBtn.innerHTML = label;
      addToCartBtn.setAttribute("data-original-text", label);
      addToCartBtn.classList.add("is-preorder");

      root.querySelectorAll(".js-product-action").forEach((el) => {
        el.classList.remove("d-none");
        el.style.display = "block";
      });
    }

    countDown() {
      const countdowns = this.querySelectorAll(".js-countdown");
      countdowns.forEach(countdown => {
        const deadline = countdown.getAttribute("data-deadline-date");
        if (!deadline) return;

        const deadlineDate = new Date(deadline).getTime();

        const setText = (sel, val) => {
          const el = countdown.querySelector(sel);
          if (el) el.textContent = String(val);
        };

        const update = () => {
          const now = Date.now();
          const distance = deadlineDate - now;

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (distance <= 0) {
            days = hours = minutes = seconds = 0;
            clearInterval(timerId);
          }

          setText(".js-countdown-days", days);
          setText(".js-countdown-hours", hours);
          setText(".js-countdown-minutes", minutes);
          setText(".js-countdown-seconds", seconds);
        };

        update();
        const timerId = setInterval(update, 1000);
      });
    }

    photoswipeZoom() {
      const lightbox = new PhotoSwipeLightbox({
        gallery: '.js-pswp-gallery',
        children: 'a[data-pswp-width][data-pswp-height]',
        pswpModule: PhotoSwipe
      });
      lightbox.init();
    }
  };

  if(!customElements.get("product-page")) {
    customElements.define("product-page", window.Product);
  }

  for (let i = 1; i <= 15; i++) {
    for (let s of [1, 2, 3, 4, 5]) {
      let tagName = `product-page-home-${i}-${s}`;
      if (document.querySelector(tagName) && !customElements.get(tagName)) {
        customElements.define(tagName, class extends window.Product {});
      }
    } 
  }
})();
document.addEventListener("DOMContentLoaded", function () {
  //if (window.innerWidth > 991) return;

  const actionWrap = document.querySelector(".js-product-action");
  const trigger = document.getElementById("atc-sticky-trigger");
  const cartDrawer = document.querySelector(".icart-slider-drawer");

  if (!actionWrap || !trigger) return;

  const OFFSET = 50;

  window.addEventListener(
    "scroll",
    function () {
      const triggerRect = trigger.getBoundingClientRect();

      if (triggerRect.bottom < -OFFSET) {
        actionWrap.classList.add("is-sticky");
      } else {
        actionWrap.classList.remove("is-sticky");
      }
    },
    { passive: true }
  );

  if (cartDrawer) {
    const drawerObserver = new MutationObserver(() => {
      if (cartDrawer.classList.contains("active")) {
        actionWrap.classList.add("is-sticky-hidden");
      } else {
        actionWrap.classList.remove("is-sticky-hidden");
      }
    });

    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
});